const frontColor = 'hsl(196, 37%, 13%)';

const charts = {
  red: {
    bars: 'red',
  },
  orange: {
    bars: 'orange',
  },
  green: {
    bars: 'green',
  },
  blue: {
    bars: 'blue',
  },
  orange_kb: {
    bars: 'orange',
  },
  violet: {
    bars: 'violet',
  },
  turquoise: {
    bars: 'turquoise',
  },
  vivid: {
    bars: 'yellow',
  },
  grey: {
    bars: 'grey',
  },
  common: {
    axis: {
      stroke: frontColor,
      title: frontColor,
    },
    bars: frontColor,
    background: 'hsl(200deg 20% 98%)',
    grid: {
      stroke: frontColor,
      opacity: '0.1',
    },
    toolTip: {
      backgroundColor: 'rgb(232, 241, 255)',
      border: '1px solid #07c',
      color: frontColor,
      padding: '.3rem .5rem',
      borderRadius: '3px',
      fontSize: '18px',
      boxShadow: '0 1px 2px rgba(33,33,33,0.2)',
      lineHeight: '1em',
    },
  },
};

export default charts;
